export default __webpack_public_path__ + "static/media/removing-file.6b444b14.png";